export default __webpack_public_path__ + "locales/ar-SA/FillPDFDialog.json?hash=4beec7989125688dec0fd723d2d56db3";